import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild,} from '@angular/core';
import {
  ConfirmationModalComponent,
  PaginationData,
  SortDirection,
  SortHelper,
  SortService,
  sortData,
  TableColumn,
  ToastConfig,
} from '@app/shared';
import {NzDrawerService} from 'ng-zorro-antd/drawer';
import {combineLatest, debounceTime, distinctUntilChanged, fromEvent, Subject, take, takeUntil,} from 'rxjs';
import {MaestrosUtilsService} from '../../features/maestros/services/maestros-utils.service';
import {NzModalService} from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import {
  MaestrosDetailsDrawerComponent
} from 'src/app/features/maestros/drawers/maestros-details-drawer/maestros-details-drawer.component';
import {FlowComponent} from '../../features/maestros/pages/flow/flow.component';
import {
  BUDGET_STAGES,
  deepGet,
  findBudgetStageBlock,
  getBudgetStageByValue,
  getPartnerDisplayName,
  getSafeImageUrl,
  GlobalValuesService,
  isExpirationAlert,
  OpportunityService,
  ScreenService,
} from '@app/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
  OportunitiesDetailsDrawerComponent
} from '../../features/opportunities/drawers/oportunities-details-drawer/oportunities-details-drawer.component';
import { FilterChangeEvent } from '../../features/maestros/components/maestro-filter/maestro-filter.component';
import {
  KanbanGroupingCriterion,
  KanbanStageAdd,
  KanbanStageDrop,
  LayoutKanbanComponent,
} from '../layout-kanban/layout-kanban.component';
import { resolveBudgetDrawerContext } from './budget-drawer-context.utils';

export interface PermissionsMaestros {
  create: boolean;
  edit: boolean;
  delete: boolean;
  viewDetails: boolean;
}

@Component({
  selector: 'app-expandable-table',
  standalone: false,

  templateUrl: './layout-expandable.component.html',
  styleUrl: './layout-expandable.component.less',
})
export class LayoutExpandableComponent implements OnInit, OnChanges, OnDestroy {
  private destroy$ = new Subject<void>();
  /**
   * Subject para debounciar los cambios del searchbar. Se emite en cada
   * keystroke y se consume en ngOnInit con debounceTime + distinctUntilChanged
   * para evitar spamear el backend mientras el usuario escribe.
   */
  private searchTermSubject$ = new Subject<string>();
  @Input() maestroName: string = 'Sin nombre';
  @Input() columnsData: TableColumn[] = [];
  columnsDataToShow: TableColumn[] = [];
  @Input() showDetails?: boolean = true;
  @Input() permissions: PermissionsMaestros = {
    create: true,
    edit: true,
    delete: true,
    viewDetails: true,
  };
  @Input() secondaryBtnText: string | undefined;
  @Input() createButtonText: string = 'Añadir';
  @Input() customDrawer?: {
    formComponent?: any;
    formComponentWidth?: number;
    detailsComponent?: any;
    detailsComponentWidth?: number;
    filterDrawerComponent?: any;
    groupDrawerComponent?: any;
  };
  @Input() isFlow: boolean = false;
  @Input() filterUtilsService?: any;
  @Input() expandAllByDefault: boolean = false;
  @Input() enableFilters: boolean = false;
  @Input() filterableColumns: string[] = [];
  @Input() showPageSizeSelector: boolean = false;
  private readonly allowedPageSizeOptions: number[] = [10, 25, 50, 100];
  private _pageSizeOptions: number[] = [...this.allowedPageSizeOptions];
  @Input()
  set pageSizeOptions(_: number[] | undefined) {
    this._pageSizeOptions = [...this.allowedPageSizeOptions];
  }
  get pageSizeOptions(): number[] {
    return this._pageSizeOptions;
  }
  @Output() createEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteEvent: EventEmitter<number> = new EventEmitter<number>();
  @Output() deleteMultipleEvent: EventEmitter<number[]> = new EventEmitter<
    number[]
  >();
  @Output() duplicateEvent: EventEmitter<number> = new EventEmitter<number>();
  @Output() secondaryBtnClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() markAsDoneEvent: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild('confirmationModal')
  confirmationModal!: ConfirmationModalComponent;
  @ViewChild(LayoutKanbanComponent)
  kanbanComponent?: LayoutKanbanComponent;
  private pendingDeleteId?: number;
  private pendingDeleteIds: number[] = [];
  formDrawerRef: any;
  detailsDrawerRef: any;
  filterDrawerRef: any;
  groupDrawerRef: any;
  searchValue: string = '';
  filteredData: any[] = [];
  renderData: any[] = [];
  // Columna por la que se ordena actualmente. La direccion vive en
  // activeSortColumn.sortDirection, para no duplicar el estado.
  private activeSortColumn?: TableColumn;
  viewImageModalRef: any;
  @ViewChild('viewImageModalTmpl') viewImageModalTmpl: any;
  @ViewChild('notificationTmpl') notificationTmpl: any;
  tmpImage: string = '';
  notRef: any;
  toastConfig: ToastConfig = {
    icon: 'dangerous',
    iconColor: '#CB2A2F',
    content: '',
    showUndo: false,
  };

  getSafeImageUrl = getSafeImageUrl;

  showSearch: boolean = true;
  showGlobalSearch: boolean = false;

  activeFilters: number = 0;
  activeGrouping: number = 0;
  kanbanGroupingCriteria: KanbanGroupingCriterion[] = [];
  tableLoading: boolean = false;
  viewMode: 'kanban' | 'table' = 'table';
  // Tamaño de bloque del kanban. La vista pinta el primer lote rápido y el
  // service puede completar lotes siguientes sin bloquear el render inicial.
  private readonly kanbanPageStep = 50;
  readonly tableScrollY = 'calc(100vh - 310px)';
  private resizingColumn?: TableColumn;
  private resizeStartX = 0;
  private resizeStartWidth = 0;
  private readonly resizableColumnMinWidth = 140;
  private readonly resizableColumnMaxWidth = 520;

  // Propiedades para filtrado
  filterableColumnsList: TableColumn[] = [];
  activeFiltersData: FilterChangeEvent['filters'] = [];

  paginationData: PaginationData | undefined;
  calculatedPageSize: number = 10;

  allSelected = false;
  indeterminate = false;
  selectedIds: number[] = [];
  expandSet = new Set<string | number>();
  private openedFromQueryParam: boolean = false; // Flag para saber si el drawer se abrió desde query param inicial

  constructor(
    private drawerService: NzDrawerService,
    public ms: MaestrosUtilsService,
    public gs: GlobalValuesService,
    public screenService: ScreenService,
    private modalService: NzModalService,
    private sortService: SortService,
    private router: Router,
    private route: ActivatedRoute,
    private opportunityService: OpportunityService,
    private notificationService: NzNotificationService
  ) {}

  private _tableData: any[] = [];

  get tableData() {
    return this._tableData;
  }

  @Input()
  set tableData(value: any[]) {
    // Enriquecer los datos con stageData antes de filtrar
    this._tableData = this.enrichDataWithStageData(value);
    this.filter();
    // Intentar abrir drawer cuando los datos estén disponibles
    if (this.maestroName === 'Oportunidades' || this.maestroName === 'Leads') {
      this.checkAndOpenDrawerFromQueryParams();
    }
  }

  /**
   * Obtiene una propiedad anidada de un objeto, soportando paths con sufijo Id (ej: partnerId -> partner.avatar)
   */
  getNestedProperty(item: any, path: string, nestedProp: string): any {
    if (!item || !path) return undefined;

    let objectKey = path;
    if (path.endsWith('Id')) {
      objectKey = path.slice(0, -2); // quitar 'Id'
    }

    const nestedObject = item[objectKey];
    if (!nestedObject) return undefined;

    return nestedObject[nestedProp];
  }

  /**
   * Iniciales a partir de un objeto completo o nombre/apellido
   */
  getInitials(nameOrItem?: string | any, surName?: string): string {
    if (typeof nameOrItem === 'object' && nameOrItem !== null) {
      const item = nameOrItem;
      let name = item.name;
      let surname = item.surName;
      if ((!name || !surname) && item.partner) {
        name = name || item.partner.name;
        surname = surname || item.partner.surName;
      }
      let initials = '';
      if (name && name.trim()) initials += name.trim().charAt(0).toUpperCase();
      if (surname && surname.trim()) initials += surname.trim().charAt(0).toUpperCase();
      return initials || '?';
    }

    const name = nameOrItem as string;
    if (!name && !surName) return '?';
    let initials = '';
    if (name && name.trim()) initials += name.trim().charAt(0).toUpperCase();
    if (surName && surName.trim()) initials += surName.trim().charAt(0).toUpperCase();
    return initials || '?';
  }

  /**
   * Iniciales desde un objeto anidado (ej: partnerId -> partner)
   */
  getInitialsFromNested(item: any, path: string): string {
    if (!item || !path) return '?';

    let objectKey = path;
    if (path.endsWith('Id')) {
      objectKey = path.slice(0, -2);
    }

    const nestedObject = item[objectKey];
    // Si no hay objeto anidado o no es un objeto, intentar usar el valor directo (string) como nombre completo
    if (!nestedObject || typeof nestedObject !== 'object') {
      const directVal = item[path];
      if (typeof directVal === 'string' && directVal.trim().length > 0) {
        const parts = directVal.trim().split(/\s+/);
        const first = parts[0]?.charAt(0).toUpperCase() || '';
        const second = parts[1]?.charAt(0).toUpperCase() || '';
        const initials = (first + second).trim();
        return initials || '?';
      }
      return '';
    }

    const name = nestedObject.name || '';
    const surName = nestedObject.surName || '';

    return this.getInitials(name, surName) || '';
  }

  /**
   * Retorna true si hay avatar o iniciales disponibles en una propiedad anidada
   */
  hasAvatarOrInitials(item: any, path: string): boolean {
    const avatar = this.getNestedProperty(item, path, 'avatar');
    const initials = this.getInitialsFromNested(item, path);
    return !!avatar || !!initials;
  }

  /**
   * Display name seguro desde propiedad anidada para evitar [object Object]
   */
  getNestedDisplayName(item: any, path: string, nestedPath?: string): string {
    if (!item || !path) return '-';

    let objectKey = path.endsWith('Id') ? path.slice(0, -2) : path;
    const nestedObject = item[objectKey];

    if (!nestedObject) {
      const val = nestedPath ? deepGet(item, `${path}.${nestedPath}`) : deepGet(item, path);
      return this.normalizeDisplayValue(val);
    }

    if (nestedObject.name || nestedObject.surName) {
      return this.normalizeDisplayValue(nestedObject);
    }

    if (nestedPath && nestedObject[nestedPath] !== undefined) {
      return this.normalizeDisplayValue(nestedObject[nestedPath]);
    }

    return this.normalizeDisplayValue(nestedObject);
  }

  private normalizeDisplayValue(val: any): string {
    if (val === null || val === undefined) return '-';
    if (typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean') {
      return val.toString();
    }
    if (val.name || val.surName) {
      return getPartnerDisplayName(val) || '-';
    }
    return '-';
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Si cambian las columnas, reconfigurar filtros
    if (changes['columnsData'] && !changes['columnsData'].firstChange && this.enableFilters) {
      this.setupFilterableColumns();
    }

    if (changes['maestroName']) {
      this.setDefaultViewMode();
    }
  }

  ngOnInit(): void {
    this.setDefaultViewMode();
    this.columnsDataToShow = this.columnsData.filter(
      (column) => !column.noVisibleInTable
    );
    this.configureSortFunctions();

    // Configurar columnas filtrables si los filtros están habilitados
    if (this.enableFilters) {
      this.setupFilterableColumns();
    }

    // Watcher para actualizar tableLoading
    // Usar tableLoading$ del filterUtilsService si está disponible
    if (this.filterUtilsService?.tableLoading$) {
      // Inicializar con el valor actual del BehaviorSubject
      this.tableLoading = this.filterUtilsService.tableLoading$.value;

      this.filterUtilsService.tableLoading$
        .pipe(takeUntil(this.destroy$))
        .subscribe((loading: boolean) => {
          this.tableLoading = loading;
        });
    }
    // Si no hay filterUtilsService con tableLoading$, tableLoading permanece en false (valor inicial)

    // Suscripción separada para el modal de confirmación (solo ms.loading$)
    this.ms.loading$.pipe(takeUntil(this.destroy$)).subscribe((loading) => {
      if (!loading && this.confirmationModal?.config?.processing) {
        this.confirmationModal.config.processing = false;
        this.confirmationModal.forceClose();
      }
    });

    // Suscribirse a los filtros activos si hay un servicio de filtros
    if (this.filterUtilsService?.activeFilters$) {
      this.filterUtilsService.activeFilters$
        .pipe(takeUntil(this.destroy$))
        .subscribe((count: number) => {
          this.activeFilters = count;
        });
    }

    // Suscribirse a las agrupaciones activas si hay un servicio de filtros
    if (this.filterUtilsService?.activeGrouping$) {
      this.filterUtilsService.activeGrouping$
        .pipe(takeUntil(this.destroy$))
        .subscribe((count: number) => {
          this.activeGrouping = count;
          this.kanbanGroupingCriteria = this.getKanbanGroupingCriteria();
        });
    }

    // Suscribirse a paginationData$ si está disponible
    if (this.filterUtilsService?.paginationData$) {
      this.filterUtilsService.paginationData$
        .pipe(takeUntil(this.destroy$))
        .subscribe((paginationData: PaginationData) => {
          this.paginationData = paginationData;
        });
    }

    // Sincronizar el tamaño de página inicial sin disparar una carga extra:
    // las páginas server-side cargan cuando su contexto de compañía/filtros está listo.
    this.calculatePageSize(false);

    // Escuchar cambios de tamaño de ventana
    fromEvent(window, 'resize')
      .pipe(debounceTime(100), takeUntil(this.destroy$))
      .subscribe(() => {
        this.calculatePageSize(true);
      });

    // Escuchar query params para abrir el drawer de oportunidades/leads si existe el param 'opportunity'
    if (this.maestroName === 'Oportunidades' || this.maestroName === 'Leads') {
      // Combinar route params y query params para detectar ambos casos
      combineLatest([this.route.params, this.route.queryParams])
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          // Intentar abrir drawer cuando cambien los params
          this.checkAndOpenDrawerFromQueryParams();
        });
    }

    // Debounce de la búsqueda: cada keystroke del pocket-searchbar emite en
    // searchTermSubject$; aquí esperamos 400 ms de inactividad y delegamos en
    // applySearch() para decidir si vamos al backend o filtramos client-side.
    this.searchTermSubject$
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        takeUntil(this.destroy$),
      )
      .subscribe((term) => this.applySearch(term));
  }

  isResizableColumn(column: TableColumn): boolean {
    const fieldName = column.pathData?.name || '';

    if (this.maestroName === 'Presupuestos') {
      return fieldName === 'nombre' || fieldName === 'clientCompanyDisplay';
    }

    if (this.maestroName === 'Oportunidades' || this.maestroName === 'Leads') {
      return fieldName === 'oportunidad' || fieldName === 'clientCompany';
    }

    return false;
  }

  startColumnResize(event: MouseEvent, column: TableColumn): void {
    if (!this.isResizableColumn(column)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    this.resizingColumn = column;
    this.resizeStartX = event.clientX;
    this.resizeStartWidth = this.getColumnWidthPx(column);
    document.body.classList.add('table-column-resizing');
    window.addEventListener('mousemove', this.onColumnResize);
    window.addEventListener('mouseup', this.stopColumnResize);
  }

  private onColumnResize = (event: MouseEvent): void => {
    if (!this.resizingColumn) {
      return;
    }

    const nextWidth = this.clampColumnWidth(
      this.resizeStartWidth + event.clientX - this.resizeStartX,
    );
    this.resizingColumn.width = `${nextWidth}px`;
  };

  private stopColumnResize = (): void => {
    this.resizingColumn = undefined;
    document.body.classList.remove('table-column-resizing');
    window.removeEventListener('mousemove', this.onColumnResize);
    window.removeEventListener('mouseup', this.stopColumnResize);
  };

  private getColumnWidthPx(column: TableColumn): number {
    const parsedWidth = Number.parseInt(column.width || '', 10);
    return Number.isFinite(parsedWidth)
      ? parsedWidth
      : this.resizableColumnMinWidth;
  }

  private clampColumnWidth(width: number): number {
    return Math.max(
      this.resizableColumnMinWidth,
      Math.min(this.resizableColumnMaxWidth, width),
    );
  }

  onExpandChange(id: string | number, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }

    this.refreshRenderedRows();
  }

  toggleSearch(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.showGlobalSearch = false;
    this.showSearch = !this.showSearch;
  }

  toggleGlobalSearch(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.showSearch = false;
    this.showGlobalSearch = !this.showGlobalSearch;
  }

  setViewMode(mode: 'kanban' | 'table'): void {
    const viewChanged = this.viewMode !== mode;

    this.viewMode = mode;
    this.setKanbanGroupingMode(mode === 'kanban' && this.isKanbanAvailable());
    this.applyCurrentViewPageSize(true, viewChanged);
  }

  isKanbanAvailable(): boolean {
    return (
      this.maestroName === 'Oportunidades' ||
      this.maestroName === 'Leads' ||
      this.maestroName === 'Presupuestos' ||
      this.maestroName === 'Cotizaciones'
    );
  }

  onKanbanStageDrop(event: KanbanStageDrop): void {
    if (this.maestroName === 'Oportunidades' || this.maestroName === 'Leads') {
      this.changeOpportunityKanbanStage(event);
      return;
    }

    if (this.maestroName === 'Presupuestos' || this.maestroName === 'Cotizaciones') {
      this.changeBudgetKanbanStage(event);
    }
  }

  private setDefaultViewMode(): void {
    this.viewMode = this.isKanbanAvailable() ? 'kanban' : 'table';
    this.setKanbanGroupingMode(this.viewMode === 'kanban' && this.isKanbanAvailable());
  }

  private setKanbanGroupingMode(isKanban: boolean): void {
    if (typeof this.filterUtilsService?.setKanbanPageMode === 'function') {
      this.filterUtilsService.setKanbanPageMode(isKanban);
      this.kanbanGroupingCriteria = this.getKanbanGroupingCriteria();
      return;
    }

    if (typeof this.filterUtilsService?.setKanbanGroupingMode === 'function') {
      this.filterUtilsService.setKanbanGroupingMode(isKanban);
      this.kanbanGroupingCriteria = this.getKanbanGroupingCriteria();
    }
  }

  private getKanbanGroupingCriteria(): KanbanGroupingCriterion[] {
    if (typeof this.filterUtilsService?.getKanbanGroupingCriteria !== 'function') {
      return [];
    }

    return this.filterUtilsService.getKanbanGroupingCriteria();
  }

  private changeOpportunityKanbanStage(event: KanbanStageDrop): void {
    const itemId = Number(event.item?.id || event.item?.originalId);
    const currentStageId = this.getKanbanItemStageId(event.item);
    const targetStage = this.findCompatibleKanbanStage(event.item, event.targetStage);

    if (!itemId) {
      this.kanbanComponent?.refreshFromData();
      this.showKanbanErrorToast('No se pudo identificar el registro para cambiarlo de etapa.');
      return;
    }

    if (!targetStage?.id) {
      this.kanbanComponent?.refreshFromData();
      return;
    }

    if (
      currentStageId !== null &&
      Number(currentStageId) === Number(targetStage.id)
    ) {
      return;
    }

    const request$ =
      this.maestroName === 'Oportunidades' && this.isWonKanbanStage(targetStage)
        ? this.opportunityService.markOpportunityAsWon(itemId)
        : this.maestroName === 'Leads'
        ? this.opportunityService.changeLeadStage(itemId, Number(targetStage.id))
        : this.opportunityService.changeOpportunityStage(
            itemId,
            Number(targetStage.id)
          );

    request$.pipe(take(1)).subscribe({
      next: (response: any) => {
        const responseData = response?.data || {};
        const responseStageId = responseData.stageId || responseData.stage?.id;
        this.handleOpportunityUpdate({
          ...event.item,
          ...responseData,
          stageId: responseStageId || targetStage.id,
          stage: responseData.stage || targetStage,
          etapa: targetStage.name || targetStage.label || event.targetStage.title,
        });
        this.showKanbanToast(
          'check_circle',
          '#6CDA75',
          `El registro se movió a "${event.targetStage.title}".`
        );
      },
      error: (error) => {
        this.kanbanComponent?.refreshFromData();
        this.showKanbanErrorToast(
          error?.error?.message ||
            error?.message ||
            `No fue posible mover el registro a "${event.targetStage.title}".`
        );
        console.error('Error changing kanban stage', {
          error,
          message: error?.error?.message,
          validationErrors: error?.error?.validationErrors,
          payload: {
            itemId,
            stageId: targetStage.id,
            targetOrder: event.targetStage.order,
            maestroName: this.maestroName,
          },
        });
      },
    });
  }

  private changeBudgetKanbanStage(event: KanbanStageDrop): void {
    const saleOrderId = Number(event.item?.id || event.item?.originalId);
    const targetStage = BUDGET_STAGES.find((stage) => stage.value === event.targetStage.key);

    if (!saleOrderId) {
      this.kanbanComponent?.refreshFromData();
      this.showKanbanErrorToast('No se pudo identificar el presupuesto para cambiarlo de etapa.');
      return;
    }

    if (!targetStage) {
      this.kanbanComponent?.refreshFromData();
      this.showKanbanErrorToast(
        `No es posible mover un presupuesto directamente a "${event.targetStage.title}".`
      );
      return;
    }

    if (event.item?.stage === targetStage.value) {
      return;
    }

    // Cancellation carve-out (F-2): the block guard MUST NOT run when the target is
    // cancellation — a confirmed quote may still be cancelled through this same drop.
    if (targetStage.value !== 'Cancelled') {
      const block = findBudgetStageBlock(event.item);
      if (block) {
        this.kanbanComponent?.refreshFromData();
        this.showKanbanErrorToast(block.reason);
        return;
      }
    }

    const leadId = this.getBudgetLeadId(event.item);
    if (!leadId) {
      this.kanbanComponent?.refreshFromData();
      this.showKanbanErrorToast('No es posible mover el presupuesto porque falta la oportunidad asociada.');
      console.warn('Cannot move budget without leadId', event.item);
      return;
    }

    const request$ =
      targetStage.route === 'confirm'
        ? this.opportunityService.confirmSaleOrder(saleOrderId, leadId)
        : targetStage.route === 'cancel'
          ? this.opportunityService.cancelSaleOrder(saleOrderId, leadId)
          : this.opportunityService.changeSaleOrderStage(saleOrderId, leadId, targetStage.value);

    request$.pipe(take(1)).subscribe({
      next: (response: any) => {
        // Field ownership mirrors crm-core's `ApplyStage`: only `stage`, `dateConfirm`
        // and `dateCancelled` follow from the stage itself. Cancel additionally clears
        // `dateApproved`, owned by cancel's own call site server-side.
        const patch: Record<string, unknown> = {
          ...event.item,
          ...(response?.data || {}),
          stage: targetStage.value,
          etapa: event.targetStage.title,
          dateConfirm: targetStage.value === 'SaleOrder'
            ? (response?.data?.dateConfirm || event.item?.dateConfirm || new Date().toISOString())
            : null,
          dateCancelled: targetStage.value === 'Cancelled'
            ? (response?.data?.dateCancelled || new Date().toISOString())
            : null,
        };
        if (targetStage.value === 'Cancelled') {
          patch['dateApproved'] = null;
        }
        patch['originalBudget'] = {
          ...(event.item?.originalBudget || {}),
          ...(response?.data || {}),
          stage: targetStage.value,
          dateConfirm: patch['dateConfirm'],
          dateCancelled: patch['dateCancelled'],
        };

        this.handleBudgetUpdate(patch);
        this.showKanbanToast(
          'check_circle',
          '#6CDA75',
          `El presupuesto se movió a "${event.targetStage.title}".`
        );
      },
      error: (error) => {
        this.kanbanComponent?.refreshFromData();
        this.showKanbanErrorToast(
          error?.error?.message ||
            error?.message ||
            `No fue posible mover el presupuesto a "${event.targetStage.title}".`
        );
        console.error('Error changing budget stage from kanban', error);
      },
    });
  }

  private getBudgetLeadId(item: any): number | null {
    const leadId =
      item?.leadId ||
      item?.originalBudget?.leadId ||
      item?.lead?.id ||
      item?.originalBudget?.lead?.id;
    const numericLeadId = Number(leadId);

    return Number.isFinite(numericLeadId) && numericLeadId > 0 ? numericLeadId : null;
  }

  private normalizeTextKey(value: any): string {
    return String(value || '')
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  private findCompatibleKanbanStage(item: any, targetStage: KanbanStageDrop['targetStage']): any {
    const allStages = this.gs.stages$.value || [];
    const target = allStages.find(
      (stage: any) => Number(stage?.id) === Number(targetStage.id || targetStage.key)
    );

    if (!target) {
      return null;
    }

    const currentStageId = this.getKanbanItemStageId(item);
    const currentStage = allStages.find(
      (stage: any) => Number(stage?.id) === Number(currentStageId)
    );
    const teamId =
      this.getKanbanItemTeamId(item) ||
      this.getSingleStageTeamId(item?.stage) ||
      this.getSingleStageTeamId(item?.originalStage) ||
      this.getSingleStageTeamId(currentStage);

    if (teamId) {
      if (this.stageBelongsToTeam(target, teamId)) {
        return target;
      }

      this.showKanbanErrorToast(
        `No es posible mover este registro a "${targetStage.title}" porque la etapa no pertenece a su equipo comercial.`
      );
      this.kanbanComponent?.refreshFromData();
      console.warn('Incompatible stage for kanban drop', {
        itemId: item?.id || item?.originalId,
        teamId,
        targetStage: target,
      });
      return null;
    }

    return target;
  }

  private isWonKanbanStage(stage: any): boolean {
    return (
      stage?.completed === true ||
      this.normalizeTextKey(stage?.name || stage?.label || '') === 'adjudicada'
    );
  }

  private showKanbanErrorToast(content: string, msg?: string): void {
    this.showKanbanToast('dangerous', '#CB2A2F', content, msg);
  }

  private showKanbanToast(
    icon: string,
    iconColor: string,
    content: string,
    msg?: string
  ): void {
    if (this.notRef?.messageId) {
      this.notificationService.remove(this.notRef.messageId);
    }

    this.toastConfig = {
      icon,
      iconColor,
      content,
      msg,
      showUndo: false,
    };
    this.notRef = this.notificationService.create(
      'blank',
      '',
      this.notificationTmpl,
      { nzPlacement: 'bottomRight' }
    );
  }

  private getStageTeamIds(stage: any): Array<number | string> | null {
    if (!stage) {
      return null;
    }

    if (Array.isArray(stage.teamIds)) {
      return stage.teamIds
        .map((team: any) => team?.id ?? team)
        .filter((teamId: any) => teamId !== null && teamId !== undefined);
    }

    if (Array.isArray(stage.teams)) {
      return stage.teams
        .map((team: any) => team?.id ?? team)
        .filter((teamId: any) => teamId !== null && teamId !== undefined);
    }

    return null;
  }

  private getSingleStageTeamId(stage: any): number | string | null {
    const teamIds = this.getStageTeamIds(stage);

    return teamIds?.length === 1 ? teamIds[0] : null;
  }

  private getKanbanItemStageId(item: any): number | string | null {
    return (
      item?.stageId ||
      item?.stage_id ||
      item?.StageId ||
      item?.stage?.id ||
      item?.originalStage?.id ||
      item?.opportunity?.stageId ||
      item?.opportunity?.stage?.id ||
      item?.originalOpportunity?.stageId ||
      item?.originalOpportunity?.stage?.id ||
      item?.lead?.stageId ||
      item?.lead?.stage?.id ||
      null
    );
  }

  private getKanbanItemTeamId(item: any): number | string | null {
    return (
      item?.teamId ||
      item?.TeamId ||
      item?.salesTeamId ||
      item?.SalesTeamId ||
      item?.salesTeam?.id ||
      item?.team?.id ||
      item?.opportunity?.teamId ||
      item?.opportunity?.TeamId ||
      item?.originalOpportunity?.teamId ||
      item?.originalOpportunity?.TeamId ||
      item?.lead?.teamId ||
      item?.lead?.TeamId ||
      item?.originalBudget?.lead?.teamId ||
      item?.originalBudget?.lead?.TeamId ||
      null
    );
  }

  private stageBelongsToTeam(stage: any, teamId: number | string): boolean {
    if (stage?.isGlobal === true) {
      return true;
    }

    const numericTeamId = Number(teamId);
    const stageTeamIds = this.getStageTeamIds(stage);

    if (Array.isArray(stageTeamIds)) {
      return (
        stageTeamIds.length === 0 ||
        stageTeamIds.some((id) => Number(id) === numericTeamId)
      );
    }

    return true;
  }

  openDeleteConfirmation(elementId: number): void {
    this.pendingDeleteId = elementId;
    this.confirmationModal.config = {
      title: 'Eliminar elemento',
      message: '¿Estás seguro que deseas eliminar este elemento?',
      confirmText: 'Eliminar',
      cancelText: 'Cancelar',
      confirmButtonType: 'primary',
      confirmButtonDanger: true,
    };
    this.confirmationModal.open();
  }

  onDeleteConfirmed(data: { textValue?: string; dateValue?: Date }): void {
    this.ms.loading = true;
    // Actualizar el estado del modal para mostrar loading
    this.confirmationModal.config.processing = true;
    if (this.pendingDeleteId) {
      // Eliminación individual
      this.deleteEvent.emit(this.pendingDeleteId);
      this.pendingDeleteId = undefined;
    } else if (this.pendingDeleteIds.length > 0) {
      // Eliminación múltiple - emitir un solo evento con todos los IDs
      this.deleteMultipleEvent.emit([...this.pendingDeleteIds]);
      // Limpiar selecciones después de eliminar
      this.selectedIds = [];
      this.updateSelectionState();
      this.pendingDeleteIds = [];
    }
  }

  openDeleteMultipleConfirmation(): void {
    if (this.selectedIds.length === 0) return;

    this.pendingDeleteIds = [...this.selectedIds];
    this.confirmationModal.config = {
      title: 'Eliminar elementos',
      message: `¿Estás seguro que deseas eliminar ${this.selectedIds.length} elemento(s) seleccionado(s)?`,
      confirmText: 'Eliminar',
      cancelText: 'Cancelar',
      confirmButtonType: 'primary',
      confirmButtonDanger: true,
    };
    this.confirmationModal.open();
  }
  openEditFormDrawer(item?: any): void {
    if (item) {
      // Emitir evento de actualización con el item para abrir drawer de edición
      this.updateEvent.emit({ item });
    } else {
      this.updateEvent.emit('Open edit form drawer');
    }
  }

  openFormDrawer(editingItem?: any): void {
    this.createEvent.emit(editingItem || 'Open add form drawer');
  }

  onKanbanStageAdd(event: KanbanStageAdd): void {
    if (!this.permissions.create) {
      return;
    }

    if (this.maestroName === 'Presupuestos' || this.maestroName === 'Cotizaciones') {
      this.showKanbanToast(
        'dangerous',
        '#CB2A2F',
        'Los presupuestos deben crearse desde una oportunidad.'
      );
      return;
    }

    if (!Number.isFinite(Number(event.targetStage.id ?? event.targetStage.key))) {
      this.showKanbanToast(
        'dangerous',
        '#CB2A2F',
        'Las etapas todavía se están cargando. Intenta nuevamente en unos segundos.'
      );
      return;
    }

    this.openFormDrawer({
      action: 'kanban-add-card',
      targetStage: event.targetStage,
    });
  }

  // Método para abrir drawer de detalles (botón de panel lateral)
  openDetailsDrawerFromButton(item: any): void {
    this.openDetailsDrawer(item);
  }

  /**
   * Handler del evento `searchEvent` del pocket-searchbar. Empuja el valor
   * actual a `searchTermSubject$` para que el pipe con debounce decida cuándo
   * ejecutar la búsqueda real.
   */
  onSearchChanged(): void {
    this.searchTermSubject$.next(this.searchValue || '');
  }

  /**
   * Aplica la búsqueda cuando el debounce se completa. Si el
   * `filterUtilsService` soporta búsqueda server-side (expone `setSearchTerm`
   * y alguno de los métodos de carga `getOpportunities` / `getBudgets`), se
   * delega en él reseteando a la página 1 para que el backend devuelva el
   * dataset completo filtrado. En caso contrario se mantiene el comportamiento
   * original client-side llamando a `filter()`.
   */
  private applySearch(term: string): void {
    const svc = this.filterUtilsService;
    if (svc && typeof svc.setSearchTerm === 'function') {
      svc.setSearchTerm(term);

      // Oportunidades y Leads comparten OpportunitiesUtilsService y distinguen
      // por tipo mediante getCurrentType(); Budgets usa BudgetsUtilsService con
      // un getBudgets() sin parámetro de tipo.
      if (typeof svc.getOpportunities === 'function') {
        const currentType =
          typeof svc.getCurrentType === 'function'
            ? svc.getCurrentType()
            : undefined;
        svc.getOpportunities({ resetPage: true, type: currentType });
        return;
      }

      if (typeof svc.getBudgets === 'function') {
        svc.getBudgets({ resetPage: true });
        return;
      }
    }

    // Fallback: filtrado client-side sobre la página ya cargada.
    this.filter();
  }

  filter(): void {
    let tempFilteredData = this.tableData;

    // Obtener todas las propiedades de tipo texto y que se muestren en la tabla
    const toFilterProps: string[] = this.columnsData
      .filter(
        (cd) =>
          !cd.noVisibleInTable &&
          (cd.pathData?.type === 'text' || cd.pathData?.type === 'number')
      )
      .map((cd) => cd.pathData!.name);

    // Obtener todas las propiedades anidadas y que se muestren en la tabla
    const nestedProps: TableColumn[] = this.columnsData.filter(
      (cd) =>
        !cd.noVisibleInTable &&
        (cd.pathData?.type === 'select' ||
          cd.pathData?.type === 'multi-select' ||
          cd.pathData?.type === 'avatar-select')
    );

    // Si el service hace búsqueda server-side (expone setSearchTerm), el
    // backend ya devolvió las filas correctas para el término actual; saltarse
    // el filtrado client-side por texto evita que las columnas mal tipadas
    // (p.ej. avatar-select sin nestedPath en Budgets) eliminen todas las
    // filas devueltas por el backend.
    const serverSideSearchEnabled =
      this.filterUtilsService &&
      typeof this.filterUtilsService.setSearchTerm === 'function';

    // Solo filtrar client-side si hay valor de búsqueda, propiedades y el
    // service NO gestiona la búsqueda server-side.
    if (
      !serverSideSearchEnabled &&
      this.searchValue?.trim() &&
      (toFilterProps.length > 0 || nestedProps.length > 0)
    ) {
      const searchTerm = this.searchValue.toLowerCase().trim();

      tempFilteredData = tempFilteredData
        .map((item) => {
          // Verificar si la fila principal coincide
          const mainRowMatches =
            // Verificar en todas las propiedades de texto
            toFilterProps.some((prop) => {
              const value = this.getPropertyValue(item, prop);
              return value?.toString().toLowerCase().includes(searchTerm);
            }) ||
            // Verificar en todas las propiedades anidadas
            nestedProps.some((prop) => {
              const currentObj = (prop.optionList || []).find(
                (opt) => opt.id === item[prop.pathData!.name]
              );
              const value = this.getPropertyValue(
                currentObj,
                prop.pathData!.nestedPath!
              );
              return value?.toString().toLowerCase().includes(searchTerm);
            });

          // Filtrar las filas secundarias (items) si existen
          let filteredItems: any[] = [];
          if (
            item.items &&
            Array.isArray(item.items) &&
            item.items.length > 0
          ) {
            filteredItems = item.items.filter((subItem: any) => {
              // Verificar en todas las propiedades de texto de la fila secundaria
              return toFilterProps.some((prop) => {
                  const value = this.getPropertyValue(subItem, prop);
                  return value?.toString().toLowerCase().includes(searchTerm);
                }) ||
                // Verificar en todas las propiedades anidadas de la fila secundaria
                nestedProps.some((prop) => {
                  const currentObj = (prop.optionList || []).find(
                    (opt) => opt.id === subItem[prop.pathData!.name]
                  );
                  const value = this.getPropertyValue(
                    currentObj,
                    prop.pathData!.nestedPath!
                  );
                  return value?.toString().toLowerCase().includes(searchTerm);
                });
            });
          }

          // Si la fila principal coincide o hay filas secundarias que coinciden
          if (mainRowMatches || filteredItems.length > 0) {
            // Crear una copia del item con las filas secundarias filtradas
            const filteredItem = { ...item };
            if (filteredItems.length > 0) {
              filteredItem.items = filteredItems;
              // Recalcular los totales de ingreso y mmr basados en las filas filtradas
              filteredItem.ingreso = filteredItems.reduce(
                (sum: number, subItem: any) => sum + (subItem.ingreso || 0),
                0
              );
              filteredItem.mmr = filteredItems.reduce(
                (sum: number, subItem: any) => sum + (subItem.mmr || 0),
                0
              );
            }
            return filteredItem;
          }
          return null;
        })
        .filter((item) => item !== null) as any[]; // Eliminar los items que no coinciden
    }

    // Aplicar filtros de campo específicos (filtros por columnas)
    if (this.enableFilters && this.activeFiltersData.length > 0) {
      tempFilteredData = tempFilteredData
        .map((item) => {
          // Verificar si el item principal cumple con todos los filtros
          const mainRowMatches = this.activeFiltersData.every(activeFilter => {
            return this.applyFieldFilter(item, activeFilter.column, activeFilter.filterValue);
          });

          // Filtrar las filas secundarias (items) si existen
          let filteredItems: any[] = [];
          if (
            item.items &&
            Array.isArray(item.items) &&
            item.items.length > 0
          ) {
            filteredItems = item.items.filter((subItem: any) => {
              return this.activeFiltersData.every(activeFilter => {
                return this.applyFieldFilter(subItem, activeFilter.column, activeFilter.filterValue);
              });
            });
          }

          // Si la fila principal coincide o hay filas secundarias que coinciden
          if (mainRowMatches || filteredItems.length > 0) {
            const filteredItem = { ...item };
            if (filteredItems.length > 0 && !mainRowMatches) {
              filteredItem.items = filteredItems;
            }
            return filteredItem;
          }
          return null;
        })
        .filter((item) => item !== null) as any[];
    }

    // Enriquecer los datos filtrados con stageData y reaplicar el orden activo
    this.filteredData = this.applyActiveSort(
      this.enrichDataWithStageData(tempFilteredData)
    );

    // Expandir todos los elementos por defecto si est? habilitado
    if (this.expandAllByDefault) {
      this.expandSet.clear();
      this.addExpandableRowsToSet(this.filteredData);
    }

    this.refreshRenderedRows();
  }

  private refreshRenderedRows(): void {
    this.renderData = this.flattenGroupedRows(this.filteredData);
  }

  private flattenGroupedRows(rows: any[], level: number = 0): any[] {
    const renderedRows: any[] = [];

    rows.forEach((row) => {
      const hasChildren = Array.isArray(row.items) && row.items.length > 0;
      const isGroupRow = hasChildren || !!row.groupName;
      const renderedRow = isGroupRow
        ? { ...row, __flatGroup: hasChildren, __groupLevel: level }
        : { ...row, __groupLevel: level };

      renderedRows.push(renderedRow);

      if (hasChildren && this.expandSet.has(row.id)) {
        renderedRows.push(...this.flattenGroupedRows(row.items, level + 1));
      }
    });

    return renderedRows;
  }

  private addExpandableRowsToSet(rows: any[]): void {
    rows.forEach((item) => {
      if (item.id && item.items && item.items.length > 0) {
        this.expandSet.add(item.id);
        this.addExpandableRowsToSet(item.items);
      }
    });
  }

  getGroupIndent(item: any): number {
    return Math.max(0, Number(item?.__groupLevel || 0)) * 22;
  }

  getColumnDisplayValue(item: any, column: TableColumn): string {
    const value = column.pathData?.displayFn?.(item);
    return value || '-';
  }

  findOptionNameById(id: number, list: any[]): string {
    const selected = list.find((item) => item.id === id);

    if (selected?.name || selected?.surName) {
      return getPartnerDisplayName(selected) || '-';
    }

    return selected?.role || '-';
  }

  openViewImageModal(item: any) {
    this.tmpImage = item;
    this.viewImageModalRef = this.modalService.create({
      nzTitle: undefined,
      nzClosable: false,
      nzFooter: null,
      nzContent: this.viewImageModalTmpl,
      nzCentered: true,
    });
  }

  /**
   * Verifica los query params y route params para abrir el drawer si es necesario
   * Se llama cuando cambian los params o cuando se cargan los datos
   */
  private checkAndOpenDrawerFromQueryParams(): void {
    if (this.detailsDrawerRef) {
      return; // Ya hay un drawer abierto
    }

    const routeParams = this.route.snapshot.params;
    const queryParams = this.route.snapshot.queryParams;

    // Detectar si hay un budgetId en la ruta (acceso directo a presupuesto)
    const budgetId = routeParams['budgetId'];
    const opportunityIdFromRoute = routeParams['opportunityId'];
    const opportunityIdFromQuery = queryParams['opportunity'];

    // Usar opportunityId de route params o query params
    const opportunityId = opportunityIdFromRoute || opportunityIdFromQuery;

    if (!opportunityId) {
      return; // No hay opportunityId en los params
    }

    const oppId = Number(opportunityId);
    if (isNaN(oppId)) return;

    // Buscar la oportunidad en tableData o en items expandidos (si ya hay datos)
    let opportunity: any = null;
    if (this.tableData && this.tableData.length > 0) {
      opportunity = this.findRowById(this.tableData, oppId);
    }

    // Si no está en la tabla (datos aún no cargados o en otra página), abrir con objeto mínimo; el drawer cargará por ID
    if (!opportunity) {
      opportunity = { id: oppId, originalId: oppId };
    }

    this.openedFromQueryParam = true;
    if (budgetId) {
      this.router
        .navigate([], {
          relativeTo: this.route,
          queryParams: {
            opportunity: oppId,
            budget: budgetId,
          },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        })
        .then(() => {
          this.openDetailsDrawer(opportunity);
        });
    } else {
      this.openDetailsDrawer(opportunity);
    }
  }

  /**
   * Abre el drawer de oportunidad/lead al hacer clic en la celda de Referencia (Actividades).
   * Así el clic en el icono o en el nombre abre la oportunidad correcta.
   */
  openOpportunityDrawerFromReferenceLink(item: any): void {
    if (this.maestroName === 'Actividades' && item?.parentEntityId) {
      this.updateEvent.emit({
        openOpportunityDrawer: true,
        activity: item,
      });
    }
  }

  openDetailsDrawer(item: any): void {
    // Special handling for Actividades: emit event to parent component to open opportunity/lead drawer
    if (this.maestroName === 'Actividades' && item?.parentEntityId) {
      // Emitir evento para que el componente padre maneje la apertura del drawer
      this.updateEvent.emit({
        openOpportunityDrawer: true,
        activity: item
      });
      return;
    }

    const budgetContext = resolveBudgetDrawerContext(
      this.maestroName,
      item,
      this.route.snapshot.params,
      this.route.snapshot.queryParams,
    );

    // Special handling for Presupuestos/Cotizaciones: open drawer directly in budget mode
    if (budgetContext) {
      // First, get the opportunity data to pass to the drawer
      const { budgetId, opportunityId } = budgetContext;

      // Find the opportunity in the table data or fetch it
      let opportunity = null;

      // Try to find opportunity in filtered data
      for (const row of this.filteredData) {
        if (row.id === opportunityId || row.originalId === opportunityId) {
          opportunity = row;
          break;
        }
        // Check in expanded items
        if (row.items && Array.isArray(row.items)) {
          const found = row.items.find(
            (subItem: any) =>
              subItem.id === opportunityId ||
              subItem.originalId === opportunityId
          );
          if (found) {
            opportunity = found;
            break;
          }
        }
      }

      // If opportunity not found, we need to fetch it
      // For now, create a minimal opportunity object with the leadId
      if (!opportunity) {
        opportunity = {
          id: opportunityId,
          originalId: opportunityId,
          name: item.oportunidad || item.name || '-',
          leadId: opportunityId,
        };
      }

      // Open drawer with opportunity and set query params for budget mode
      combineLatest({
        isMobile: this.screenService.isMobile$,
        isMedium: this.screenService.isMedium$,
      })
        .pipe(take(1))
        .subscribe(({ isMobile, isMedium }) => {
          const drawerWidth = '100vw';

          this.detailsDrawerRef = this.drawerService.create({
            nzClosable: false,
            nzMask: false,
            nzWidth: drawerWidth,
            nzHeight: '98%',
            nzPlacement: isMobile ? 'bottom' : 'right',
            nzContent:
              this.customDrawer?.detailsComponent ||
              OportunitiesDetailsDrawerComponent,
            nzData: {
              columnsData: this.columnsData,
              element: opportunity,
              maestroName: 'Oportunidades',
              editPermissions: true,
              opportunityList: undefined, // No needed for budgets, drawer will load from backend
              // Pasar los IDs directamente en nzData para que el drawer los use
              budgetId,
              opportunityId: opportunityId,
            },
          });

          // Solo registrar la referencia del drawer
          // El drawer manejará los query params en updateUrlFromState()
          // No necesitamos navegar aquí
          this.detailsDrawerRef.afterOpen.pipe(take(1)).subscribe(() => {
            this.ms.detailsDrawerRef = this.detailsDrawerRef;
            // El drawer manejará los query params en updateUrlFromState()
            // No necesitamos navegar aquí

            // The kanban only repaints when this component hands it a new filteredData
            // reference, and only handleBudgetUpdate produces one. Without this
            // subscription a stage change made inside the drawer saved correctly but left
            // the card in its old column until a reload — and dragging that stale card
            // then re-sent its already-current stage to the backend. Mirrors the
            // equivalent wiring the Oportunidades/Leads branch already has.
            this.detailsDrawerRef
              .getContentComponent()
              .updateEvent?.pipe(takeUntil(this.detailsDrawerRef.afterClose))
              .subscribe((updatedBudget: any) => {
                // updateEvent is shared: the same drawer emits the opportunity on a dozen
                // other saves, and handleBudgetUpdate spreads whatever it receives onto the
                // matched row. Accept only a payload that is recognisably a quote, instead
                // of trusting that budget and opportunity ids never collide.
                if (!getBudgetStageByValue(updatedBudget?.stage)) {
                  return;
                }

                this.handleBudgetUpdate(updatedBudget);
              });
          });

          // Handle drawer close - NO limpiar query params porque estamos en budgets
          this.detailsDrawerRef.afterClose.pipe(take(1)).subscribe(() => {
            this.ms.detailsDrawerRef = undefined;
            // No limpiar query params cuando se cierra desde budgets
            // La ruta se mantiene como /opportunities/budgets
          });
        });

      return;
    }

    if (this.isFlow) {
      combineLatest({
        isMobile: this.screenService.isMobile$,
        isMedium: this.screenService.isMedium$,
      })
        .pipe(take(1))
        .subscribe(({ isMobile, isMedium }) => {
          this.formDrawerRef = this.drawerService.create({
            nzWidth: 793,
            nzHeight: '98%',
            nzPlacement: isMobile ? 'bottom' : 'right',
            nzClosable: false,
            nzMask: false,
            nzMaskClosable: false,
            nzContent: FlowComponent,
            nzData: {
              flowId: item?.id || undefined,
              readonly: true,
            },
          });
        });
    } else {
      combineLatest({
        isMobile: this.screenService.isMobile$,
        isMedium: this.screenService.isMedium$,
      })
        .pipe(take(1))
        .subscribe(({ isMobile, isMedium }) => {
          // Open the details drawer
          // Use 100vw width for opportunities and leads details drawer (same as service orders)
          const drawerWidth =
            this.customDrawer?.detailsComponentWidth ||
            (this.maestroName === 'Oportunidades' ||
            this.maestroName === 'Leads' ||
              this.maestroName === 'Presupuestos' ||
              this.maestroName === 'Cotizaciones'
              ? '100vw'
              : '500px');

          // Determinar el componente correcto del drawer
          let drawerComponent = this.customDrawer?.detailsComponent || MaestrosDetailsDrawerComponent;

          // Para Oportunidades y Leads, asegurar que siempre use OportunitiesDetailsDrawerComponent
          if ((this.maestroName === 'Oportunidades' || this.maestroName === 'Leads') &&
              drawerComponent === MaestrosDetailsDrawerComponent) {
            drawerComponent = OportunitiesDetailsDrawerComponent;
          }

          this.detailsDrawerRef = this.drawerService.create({
            nzClosable: false,
            nzMask: false,
            nzWidth: drawerWidth,
            nzHeight: '98%',
            nzPlacement: isMobile ? 'bottom' : 'right',
            nzContent: drawerComponent,
            nzData: {
              columnsData: this.columnsData,
              element: item,
              maestroName: this.maestroName,
              editPermissions: this.permissions.edit,
              // Pasar serviceId para filtrar flows (útil para service orders)
              serviceId: item?.serviceId,
              // Pasar la lista completa de oportunidades/leads para navegación (solo si es Oportunidades o Leads)
              opportunityList:
                this.maestroName === 'Oportunidades' ||
                this.maestroName === 'Leads'
                  ? this.getAllOpportunitiesFromTable()
                  : undefined,
            },
          });

          // Modificar la ruta agregando el query param con el ID de la oportunidad/lead (solo para Oportunidades o Leads)
          if (
            (this.maestroName === 'Oportunidades' ||
              this.maestroName === 'Leads') &&
            (item.id || item.originalId)
          ) {
            const opportunityId = item.id || item.originalId;
            this.router
              .navigate([], {
                relativeTo: this.route,
                queryParams: { opportunity: opportunityId },
                queryParamsHandling: 'merge',
              })
              .catch((error) => console.error('Error updating opportunity query param:', error));
          }

          // Handle drawer open and close events
          this.detailsDrawerRef.afterOpen.pipe(take(1)).subscribe(() => {
            this.ms.detailsDrawerRef = this.detailsDrawerRef;

            this.detailsDrawerRef
              .getContentComponent()
              .openEditDrawerEvent?.pipe(take(1))
              .subscribe((id: number) => {
                // Buscar el elemento en tableData o en items expandidos
                let selectedElement = this.tableData.find((i) => i.id === id);

                // Si no se encuentra en tableData, buscar en items expandidos
                if (!selectedElement) {
                  for (const item of this.tableData) {
                    if (item.items && Array.isArray(item.items)) {
                      selectedElement = item.items.find(
                        (subItem: any) =>
                          subItem.id === id || subItem.originalId === id
                      );
                      if (selectedElement) break;
                    }
                  }
                }

                this.detailsDrawerRef.close();
                // Emitir el evento de actualización con el item encontrado
                if (selectedElement) {
                  this.updateEvent.emit({ item: selectedElement });
                } else {
                  this.updateEvent.emit({ item: { id: id } });
                }
              });

            // Handle opportunity navigation event (similar to service orders)
            if (
              this.maestroName === 'Oportunidades' ||
              this.maestroName === 'Leads'
            ) {
              this.detailsDrawerRef
                .getContentComponent()
                .changeOpportunityEvent?.pipe(
                  takeUntil(this.detailsDrawerRef.afterClose)
                )
                .subscribe(
                  (data: { isNext: boolean; isPrev: boolean; id: number }) => {
                    this.handleOpportunityChange(data);
                  }
                );

              // Handle delete event from details drawer (for lead conversion)
              // When deleting from details drawer (like lead conversion), skip the backend request
              this.detailsDrawerRef
                .getContentComponent()
                .deleteEvent?.pipe(takeUntil(this.detailsDrawerRef.afterClose))
                .subscribe((id: number) => {
                  // Emit with a flag to indicate it's from conversion (skip backend request)
                  this.deleteEvent.emit({ id, skipRequest: true } as any);
                });

              // Handle update event from details drawer (when a field is updated)
              this.detailsDrawerRef
                .getContentComponent()
                .updateEvent?.pipe(takeUntil(this.detailsDrawerRef.afterClose))
                .subscribe((updatedOpportunity: any) => {
                  this.handleOpportunityUpdate(updatedOpportunity);
                });
            }
          });

          this.detailsDrawerRef.afterClose.pipe(take(1)).subscribe((result: any) => {
            this.ms.detailsDrawerRef = undefined;
            // Si el drawer cerró porque el usuario navegó a proyectos, NO redirigir a /opportunities
            if (result === 'navigatingToProjects') {
              return;
            }
            // Si ya estamos en /projects (p.ej. ngOnDestroy cerró el drawer al navegar), no redirigir
            if (this.router.url.includes('/projects/')) {
              return;
            }
            // Limpiar el queryParam 'opportunity' al cerrar el drawer (solo para Oportunidades o Leads)
            // PERO NO si el drawer se abrió desde un query param inicial (navegación directa)
            if (
              (this.maestroName === 'Oportunidades' ||
                this.maestroName === 'Leads') &&
              !this.openedFromQueryParam
            ) {
              this.router
                .navigate([], {
                  relativeTo: this.route,
                  queryParams: { opportunity: null },
                  queryParamsHandling: 'merge',
                })
                .catch((error) => console.error('Error clearing opportunity query param:', error));
            }
            // Resetear la flag cuando el drawer se cierra
            this.openedFromQueryParam = false;
          });
        });
    }
  }

  emitSecondaryBtnClick() {
    this.secondaryBtnClick.emit();
  }

  openFilterDrawerRef() {
    if (!this.customDrawer?.filterDrawerComponent) return;

    const filterDrawerComponent = this.customDrawer.filterDrawerComponent;
    this.filterDrawerRef?.close();
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    })
      .pipe(take(1))
      .subscribe(({ isMobile, isMedium }) => {
        this.filterDrawerRef = this.drawerService.create({
          nzWidth: 776,
          nzHeight: '98%',
          nzPlacement: isMobile ? 'bottom' : 'right',
          nzClosable: false,
          nzMask: true,
          nzContent: filterDrawerComponent,
        });
        this.filterDrawerRef.afterClose.pipe(take(1)).subscribe(() => {
          // Cualquier lógica adicional después de cerrar el drawer
        });
      });
  }

  openGroupDrawerRef() {
    if (!this.customDrawer?.groupDrawerComponent) return;

    const groupDrawerComponent = this.customDrawer.groupDrawerComponent;
    this.groupDrawerRef?.close();
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    })
      .pipe(take(1))
      .subscribe(({ isMobile, isMedium }) => {
        this.groupDrawerRef = this.drawerService.create({
          nzWidth: 776,
          nzHeight: '98%',
          nzPlacement: isMobile ? 'bottom' : 'right',
          nzClosable: false,
          nzMask: true,
          nzContent: groupDrawerComponent,
        });
        this.groupDrawerRef.afterClose.pipe(take(1)).subscribe(() => {
          // Cualquier lógica adicional después de cerrar el drawer
        });
      });
  }

  ngOnDestroy() {
    this.stopColumnResize();
    this.destroy$.next();
    this.destroy$.complete();
    this.searchTermSubject$.complete();
    this.formDrawerRef?.close();
    this.detailsDrawerRef?.close();
    this.filterDrawerRef?.close();
    this.groupDrawerRef?.close();
  }

  // Función auxiliar para obtener valores de propiedades anidadas
  private getPropertyValue(obj: any, path: string): any {
    return path ? path.split('.').reduce((acc, part) => acc?.[part], obj) : '';
  }

  protected readonly isExpirationAlert = isExpirationAlert;

  getDocumentTypeName(documentTypeId: number): string | undefined {
    return (this.gs.documentTypes$?.value || []).find(
      (dt) => dt.id === documentTypeId
    )?.name;
  }

  protected readonly console = console;
  protected readonly deepGet = deepGet;
  protected readonly getPartnerDisplayName = getPartnerDisplayName;

  setCurrencyData(
    rate: number,
    currencyIso: string,
    isReverse: boolean
  ): { firstIso: string; rate: number; lastIso: string } {
    if (isReverse) {
      return {
        firstIso: currencyIso,
        rate: 1 / rate,
        lastIso: 'USD',
      };
    } else {
      return {
        firstIso: 'USD',
        rate: rate,
        lastIso: currencyIso,
      };
    }
  }

  // Métodos para el sistema de ordenamiento
  private configureSortFunctions(): void {
    SortHelper.configureSortFunctions(this.columnsDataToShow, (column) =>
      this.handleSort(column)
    );
  }

  private handleSort(column: TableColumn): void {
    if (!column.pathData) return;

    const currentDirection = column.sortDirection || null;
    const { sortedData, newDirection } = this.sortService.applySort(
      this.filteredData,
      column,
      currentDirection
    );

    // Resetear otras columnas y actualizar la actual
    SortHelper.resetOtherColumns(this.columnsDataToShow, column);
    column.sortDirection = newDirection;
    this.activeSortColumn = newDirection ? column : undefined;

    // Actualizar los datos filtrados
    this.filteredData = sortedData;
    this.refreshRenderedRows();
  }

  /**
   * Reaplica el orden vigente. `filter()` reconstruye filteredData desde
   * tableData, asi que sin esto el orden se perderia en cada cambio de datos
   * (eliminar, crear o editar), busqueda o filtro.
   */
  private applyActiveSort(rows: any[]): any[] {
    const column = this.activeSortColumn;
    const direction = column?.sortDirection ?? null;

    if (!column || !direction) {
      return rows;
    }

    return sortData(rows, { column, direction });
  }

  // Método para obtener la dirección de ordenamiento de una columna
  getColumnSortDirection(column: TableColumn): SortDirection {
    return SortHelper.getColumnSortDirection(column);
  }

  updateSelectionState(): void {
    const totalCount = this.getSelectableRows(this.filteredData).length;
    const selectedCount = this.selectedIds.length;

    this.allSelected = totalCount > 0 && selectedCount === totalCount;
    this.indeterminate = selectedCount > 0 && selectedCount < totalCount;
  }

  onSelectAll(checked: boolean): void {
    if (checked) {
      this.selectedIds = this.getSelectableRows(this.filteredData)
        .map((item) => item.id)
        .filter((id): id is number => typeof id === 'number');
    } else {
      this.selectedIds = [];
    }
    this.updateSelectionState();

    // Emitir evento al componente padre si es necesario
    // this.selectionChange.emit(this.selectedIds);
  }

  onSelectItem(id: number, checked: boolean): void {
    if (checked) {
      this.selectedIds.push(id);
    } else {
      this.selectedIds = this.selectedIds.filter(
        (selectedId) => selectedId !== id
      );
    }
    this.updateSelectionState();

    // Emitir evento al componente padre si es necesario
    // this.selectionChange.emit(this.selectedIds);
  }

  // Get all opportunities from table (including expanded items)
  private getAllOpportunitiesFromTable(): any[] {
    return this.getSelectableRows(this.tableData);
  }

  private getSelectableRows(rows: any[]): any[] {
    const selectableRows: any[] = [];

    const collectRows = (items: any[]) => {
      (items || []).forEach((item) => {
        if (item.items && Array.isArray(item.items) && item.items.length > 0) {
          collectRows(item.items);
          return;
        }

        if (!item.groupName && (item.id || item.originalId)) {
          selectableRows.push(item);
        }
      });
    };

    collectRows(rows || []);
    return selectableRows;
  }

  private findRowById(rows: any[], id: number): any | null {
    for (const item of rows || []) {
      if (item.id === id || item.originalId === id) {
        return item;
      }

      if (item.items && Array.isArray(item.items)) {
        const row = this.findRowById(item.items, id);
        if (row) {
          return row;
        }
      }
    }

    return null;
  }

  private sumRowsByField(rows: any[], field: string): number {
    return (rows || []).reduce((sum, item) => {
      if (item.items && Array.isArray(item.items) && item.items.length > 0) {
        return sum + this.sumRowsByField(item.items, field);
      }

      return sum + (Number(item[field]) || 0);
    }, 0);
  }

  /**
   * Calcula la información de la etapa según el teamId y stageId de la oportunidad
   * @param item - El item de la oportunidad que contiene stageId y teamId
   * @returns Objeto con label, backgroundColor y color para mostrar la etapa, o null si no se encuentra
   */
  private calculateStageData(
    item: any
  ): { label: string; backgroundColor: string; color: string } | null {
    if (!item) return null;

    // Manejar budgets (Presupuestos/Cotizaciones) que usan stage como string
    if ((this.maestroName === 'Presupuestos' || this.maestroName === 'Cotizaciones') && item.stage) {
      const budgetStageStyles: {
        [key: string]: {
          label: string;
          backgroundColor: string;
          color: string;
        };
      } = {
        Budget: {
          label: 'Presupuesto',
          backgroundColor: '#EBF5FF',
          color: '#0072F5',
        },
        BudgetSent: {
          label: 'Presupuesto enviado',
          backgroundColor: '#F9F1FE',
          color: '#8E4EC6',
        },
        SaleOrder: {
          label: 'Pedido de venta',
          backgroundColor: '#EBFAEB',
          color: '#6CDA75',
        },
      };

      const style = budgetStageStyles[item.stage];
      if (style) {
        return style;
      }

      // Si no hay estilo predefinido, usar valores por defecto
      return {
        label: item.etapa || item.stage || 'Desconocido',
        backgroundColor: '#EBEBEB',
        color: '#171717',
      };
    }

    const stageId = item.stageId;
    const teamId = item.teamId;

    if (!stageId) return null;

    // Obtener todos los stages disponibles
    const allStages = this.gs.stages$.value;

    // Buscar el stage por stageId y teamId (si está disponible)
    let stage: any = null;

    if (teamId) {
      stage = allStages.find(
        (s: any) => {
          return (
            s.id === stageId &&
            this.stageBelongsToTeam(s, teamId)
          );
        }
      );
    }

    // Si no se encuentra con teamId, buscar solo por stageId
    if (!stage) {
      stage = allStages.find((s: any) => s.id === stageId);
    }

    // Si aún no se encuentra, retornar null
    if (!stage) return null;

    // Mapa de estilos para las etapas comunes
    const stageStyles: {
      [key: string]: { label: string; backgroundColor: string; color: string };
    } = {
      Presupuesto: {
        label: 'Presupuesto',
        backgroundColor: '#FFF4D6',
        color: '#A35200',
      },
      Nuevo: {
        label: 'Nuevo',
        backgroundColor: '#EBF5FF',
        color: '#0068D6',
      },
      Inicio: {
        label: 'Inicio',
        backgroundColor: '#E8F4F8',
        color: '#0066CC',
      },
      Evaluación: {
        label: 'Evaluación',
        backgroundColor: '#F9F1FE',
        color: '#7820BC',
      },
      Pausada: {
        label: 'Pausada',
        backgroundColor: '#FEECF2',
        color: '#BD2864',
      },
      Adjudicada: {
        label: 'Adjudicada',
        backgroundColor: '#EBFAEB',
        color: '#297A3A',
      },
      Completada: {
        label: 'Completada',
        backgroundColor: '#D4EDDA',
        color: '#155724',
      },
      Cancelada: {
        label: 'Cancelada',
        backgroundColor: '#FFEBEB',
        color: '#CB2A2F',
      },
    };

    const stageName = stage.name || stage.label || '';
    const style = stageStyles[stageName];

    if (style) {
      return style;
    }

    // Si no hay estilo predefinido, usar valores por defecto
    return {
      label: stageName || 'Desconocido',
      backgroundColor: '#EBEBEB',
      color: '#171717',
    };
  }

  /**
   * Enriquece los datos agregando la propiedad stageData a cada item
   * @param data - Array de items a enriquecer
   * @returns Array de items enriquecidos con stageData
   */
  private enrichDataWithStageData(data: any[]): any[] {
    return data.map((item) => {
      const enrichedItem = { ...item };

      // Agregar stageData al item principal
      enrichedItem.stageData = this.calculateStageData(item);

      // Si tiene items expandidos, tambi?n agregar stageData recursivamente.
      if (item.items && Array.isArray(item.items)) {
        enrichedItem.items = this.enrichDataWithStageData(item.items);
      }


      return enrichedItem;
    });
  }

  // Handle opportunity update from details drawer
  private handleOpportunityUpdate(updatedOpportunity: any): void {
    if (!updatedOpportunity) return;

    const opportunityId =
      updatedOpportunity.id || updatedOpportunity.originalId;
    if (!opportunityId) return;

    // Función helper para actualizar una oportunidad en un árbol agrupado.
    const updateOpportunityInData = (data: any[]): any[] => {
      return data.map((item: any) => {
        if (
          !item.groupName &&
          (item.id === opportunityId || item.originalId === opportunityId)
        ) {
          const enrichedItem = { ...item, ...updatedOpportunity };
          enrichedItem.stageData = this.calculateStageData(enrichedItem);
          return enrichedItem;
        }

        if (item.items && Array.isArray(item.items)) {
          const updatedItems = updateOpportunityInData(item.items);
          const updatedItem = { ...item, items: updatedItems };

          if (updatedItem.ingreso !== undefined) {
            updatedItem.ingreso = this.sumRowsByField(updatedItems, 'ingreso');
          }

          if (updatedItem.mmr !== undefined) {
            updatedItem.mmr = this.sumRowsByField(updatedItems, 'mmr');
          }

          return updatedItem;
        }

        return item;
      });
    };

    // Buscar y actualizar la oportunidad en tableData
    this._tableData = updateOpportunityInData(this._tableData);

    // Actualizar también el servicio si es OpportunitiesUtilsService
    if (
      this.filterUtilsService &&
      this.filterUtilsService.filteredOpportunities$ &&
      (this.maestroName === 'Oportunidades' || this.maestroName === 'Leads')
    ) {
      const currentData =
        this.filterUtilsService.filteredOpportunities$.value || [];
      const updatedData = updateOpportunityInData(currentData);

      // Actualizar el BehaviorSubject del servicio
      this.filterUtilsService.filteredOpportunities$.next(updatedData);

      // También actualizar totalOpportunities si existe
      if (this.filterUtilsService.totalOpportunities) {
        this.filterUtilsService.totalOpportunities = updatedData;
      }
    }

    // Aplicar filtros y enriquecer con stageData
    this.filter();
  }

  private handleBudgetUpdate(updatedBudget: any): void {
    if (!updatedBudget) return;

    const budgetId = updatedBudget.id || updatedBudget.originalId;
    if (!budgetId) return;

    const updateBudgetInData = (data: any[]): any[] => {
      return data.map((item: any) => {
        if (!item.groupName && (item.id === budgetId || item.originalId === budgetId)) {
          const enrichedItem = { ...item, ...updatedBudget };
          enrichedItem.stageData = this.calculateStageData(enrichedItem);
          return enrichedItem;
        }

        if (item.items && Array.isArray(item.items)) {
          const updatedItems = updateBudgetInData(item.items);
          const updatedItem = { ...item, items: updatedItems };

          if (updatedItem.total !== undefined) {
            updatedItem.total = this.sumRowsByField(updatedItems, 'total');
          }

          return updatedItem;
        }

        return item;
      });
    };

    this._tableData = updateBudgetInData(this._tableData);

    if (this.filterUtilsService?.filteredBudgets$) {
      const currentData = this.filterUtilsService.filteredBudgets$.value || [];
      const updatedData = updateBudgetInData(currentData);
      this.filterUtilsService.filteredBudgets$.next(updatedData);

      if (this.filterUtilsService.totalBudgets) {
        this.filterUtilsService.totalBudgets = updatedData;
      }
    }

    // The published list is not the board's source of rows: the service republishes
    // its own kanban accumulator on every load, so patching only what is published
    // leaves the stale row to come straight back. Patch it there too.
    this.filterUtilsService?.patchAccumulatedBudget?.(updatedBudget);

    this.filter();
  }

  // Handle opportunity change navigation
  private handleOpportunityChange(data: {
    isNext: boolean;
    isPrev: boolean;
    id: number;
  }): void {
    const allOpportunities = this.getAllOpportunitiesFromTable();
    if (allOpportunities.length === 0) return;

    const currentIndex = allOpportunities.findIndex(
      (opp) => opp.id === data.id || opp.originalId === data.id
    );

    if (currentIndex === -1) return;

    let newIndex: number;
    if (data.isNext) {
      newIndex = currentIndex + 1;
      if (newIndex >= allOpportunities.length) {
        newIndex = 0; // Volver al inicio
      }
    } else if (data.isPrev) {
      newIndex = currentIndex - 1;
      if (newIndex < 0) {
        newIndex = allOpportunities.length - 1; // Ir al final
      }
    } else {
      // Selección directa
      newIndex = allOpportunities.findIndex(
        (opp) => opp.id === data.id || opp.originalId === data.id
      );
    }

    if (newIndex !== -1 && newIndex < allOpportunities.length) {
      const newOpportunity = allOpportunities[newIndex];
      const drawerComponent = this.detailsDrawerRef.getContentComponent();

      // Actualizar la oportunidad en el drawer usando el método público
      // que actualiza todas las propiedades computadas (nombre, stepper, etc.)
      if (drawerComponent.updateOpportunityData) {
        drawerComponent.updateOpportunityData(newOpportunity);
      } else {
        // Fallback: actualizar directamente si el método no existe
        drawerComponent.opportunity = newOpportunity;
      }

      // Actualizar el query param con el nuevo ID
      const newOpportunityId = newOpportunity.id || newOpportunity.originalId;
      if (newOpportunityId) {
        this.router
          .navigate([], {
            relativeTo: this.route,
            queryParams: { opportunity: newOpportunityId },
            queryParamsHandling: 'merge',
          })
          .catch((error) => console.error('Error updating opportunity query param:', error));
      }

      // Recargar los datos del drawer solo si no se usó updateOpportunityData
      // (porque updateOpportunityData ya maneja la recarga de documentos)
      if (!drawerComponent.updateOpportunityData) {
        drawerComponent.loading = true;

        // Recargar documentos si es necesario
        if (newOpportunity?.documents?.length) {
          drawerComponent.documents = newOpportunity.documents;
        } else if (newOpportunity?.id || newOpportunity?.originalId) {
          drawerComponent.loadOpportunityDocuments(
            newOpportunity?.id || newOpportunity?.originalId
          );
        }

        drawerComponent.loading = false;
      }
    }
  }

  /** Metodos de paginacion **/
  //region Paginacion
  pageIndexChange(index: number): void {
    if (this.filterUtilsService?.setCurrentPage) {
      this.filterUtilsService.setCurrentPage(index);
      return;
    }

    // Intentar llamar al método de recarga de datos del servicio
    // Diferentes servicios pueden tener diferentes nombres de métodos
    if (this.filterUtilsService?.getOpportunities) {
      this.filterUtilsService.getOpportunities({ page: index });
    } else if (this.filterUtilsService?.getServiceOrders) {
      this.filterUtilsService.getServiceOrders({ page: index });
    } else if (this.filterUtilsService?.getBudgets) {
      this.filterUtilsService.getBudgets({ page: index });
    } else if (this.filterUtilsService?.getActivities) {
      this.filterUtilsService.getActivities({ page: index });
    } else if (this.filterUtilsService?.filter) {
      // Algunos servicios pueden tener un método filter genérico
      this.filterUtilsService.filter(true);
    }
  }

  pageSizeChange(size: number): void {
    const pageSize = this.normalizePageSize(size);
    this.calculatedPageSize = pageSize;

    if (this.filterUtilsService?.setPageSize) {
      this.filterUtilsService.setPageSize(pageSize, true);
      return;
    }

    this.paginationData = {
      ...(this.paginationData || {
        startRow: 0,
        endRow: 0,
        currentPage: 1,
        totalPages: 1,
        totalItems: this.filteredData.length,
      }),
      pageSize,
      currentPage: 1,
    };
  }

  // Método para calcular el tamaño de página basado en la altura disponible
  private calculatePageSize(reload: boolean): void {
    if (this.showPageSizeSelector) {
      if (this.viewMode === 'kanban' && this.isKanbanAvailable()) {
        this.applyCurrentViewPageSize(reload);
      }
      return;
    }

    // Altura aproximada de una fila de tabla
    const rowHeight = 44;
    // Altura de los elementos fijos
    const fixedElementsHeight = 280;

    // Calcular altura disponible
    const windowHeight = window.innerHeight;
    const availableHeight = windowHeight - fixedElementsHeight;

    // Calcular cuántas filas caben
    const rowsThatFit = Math.floor(availableHeight / rowHeight);

    // Establecer el tamaño de página (mínimo 5 filas)
    this.calculatedPageSize = Math.max(5, rowsThatFit);

    this.applyCurrentViewPageSize(reload);
  }

  private applyCurrentViewPageSize(reload: boolean, forceReload: boolean = false): void {
    const pageSize =
      this.viewMode === 'kanban' && this.isKanbanAvailable()
        ? this.kanbanPageStep
        : this.calculatedPageSize;

    if (this.filterUtilsService?.setPageSize) {
      this.filterUtilsService.setPageSize(pageSize, reload, forceReload);
      return;
    }

    if (this.filterUtilsService?.updatePageSize) {
      const currentPageSize = this.paginationData?.pageSize;

      if (currentPageSize === pageSize) {
        return;
      }

      this.filterUtilsService.updatePageSize(pageSize);
    }
  }

  private normalizePageSize(pageSize: number): number {
    const parsed = Math.floor(Number(pageSize));
    if (!Number.isFinite(parsed)) return 10;
    if (parsed >= 100) return 100;
    if (parsed > 50) return 100;
    if (parsed > 25) return 50;
    if (parsed > 10) return 25;
    return 10;
  }

  /**
   * Configura las columnas filtrables basándose en filterableColumns o filterable
   */
  setupFilterableColumns(): void {
    const columnsForTable = this.columnsData;

    if (this.filterableColumns && this.filterableColumns.length > 0) {
      const filtered = columnsForTable.filter(
        (column) => this.filterableColumns!.includes(column.name)
      );

      // Si hay duplicados por nombre, preferir las que tienen filterable: true y type: 'select'
      const uniqueMap = new Map<string, TableColumn>();
      filtered.forEach(column => {
        const existing = uniqueMap.get(column.name);
        if (!existing) {
          uniqueMap.set(column.name, column);
        } else {
          // Preferir columnas con filterable: true y type: 'select'
          const newIsFilterable = column.filterable === true && column.pathData?.type === 'select';
          const existingIsFilterable = existing.filterable === true && existing.pathData?.type === 'select';
          if (newIsFilterable && !existingIsFilterable) {
            uniqueMap.set(column.name, column);
          }
        }
      });

      this.filterableColumnsList = Array.from(uniqueMap.values());
    } else {
      this.filterableColumnsList = columnsForTable.filter(
        (column) => column.filterable && !column.noVisibleInTable
      );
    }
  }

  /**
   * Maneja el cambio de filtro desde el componente hijo
   */
  onFilterChange(event: FilterChangeEvent): void {
    this.activeFiltersData = event.filters;
    this.filter();
  }

  /**
   * Maneja la limpieza del filtro
   */
  onFilterClear(): void {
    this.activeFiltersData = [];
    this.filter();
  }

  /**
   * Aplica el filtro según el tipo de campo
   */
  private applyFieldFilter(item: any, column: TableColumn, filterValue: any): boolean {
    if (filterValue === null || filterValue === undefined ||
        (filterValue === '' && column.pathData?.type !== 'boolean')) {
      return true;
    }

    const pathData = column.pathData;
    if (!pathData) return true;

    let itemValue: any;

    // Obtener el valor del item según el tipo de columna
    if (pathData.type === 'avatar-select') {
      // Para avatar-select, el valor puede ser un objeto directo o un ID
      const itemData = item[pathData.name];
      if (itemData && typeof itemData === 'object') {
        // Si es un objeto, obtener el nombre usando nestedPath
        if (pathData.nestedPath) {
          itemValue = this.getPropertyValue(itemData, pathData.nestedPath);
        } else {
          // Si no hay nestedPath, construir el nombre completo
          itemValue = getPartnerDisplayName(itemData) || itemData.name;
        }
      } else {
        // Si es un ID, buscar en optionList
        const currentObj = (column.optionList || []).find(
          (opt) => opt.id === itemData
        );
        itemValue = this.getPropertyValue(currentObj, pathData.nestedPath || 'name');
      }
    } else if (pathData.type === 'select') {
      const itemData = item[pathData.name];

      // Si el itemData es un objeto con la propiedad nestedPath, extraer el valor directamente
      if (itemData && typeof itemData === 'object' && pathData.nestedPath) {
        itemValue = this.getPropertyValue(itemData, pathData.nestedPath);
      } else {
        // Si es un ID, buscar en optionList
        const currentObj = (column.optionList || []).find(
          (opt) => opt.id === itemData
        );
        itemValue = this.getPropertyValue(currentObj, pathData.nestedPath || 'name');
      }
    } else if (pathData.type === 'multi-select') {
      // Para multi-select, itemValue es el array de objetos
      itemValue = item[pathData.name];
    } else if (pathData.nestedPath) {
      const nestedObj = item[pathData.name];
      itemValue = this.getPropertyValue(nestedObj, pathData.nestedPath);
    } else if (pathData.type === 'badge') {
      // Para badges, obtener el valor directamente
      itemValue = item[pathData.name];
    } else {
      itemValue = item[pathData.name];
    }

    // Aplicar filtro según el tipo
    switch (pathData.type) {
      case 'text':
      case 'badge':
        return itemValue?.toString().toLowerCase().includes(
          filterValue?.toString().toLowerCase()
        );

      case 'number':
        return itemValue?.toString().includes(
          filterValue?.toString()
        );

      case 'date':
        if (!filterValue) return true;
        const filterDate = new Date(filterValue);
        const itemDate = new Date(itemValue);
        return filterDate.toDateString() === itemDate.toDateString();

      case 'select':
      case 'avatar-select':
        return item[pathData.name] === filterValue ||
               itemValue?.toString().toLowerCase() ===
               filterValue?.toString().toLowerCase();

      case 'multi-select':
        // filterValue es un array de IDs seleccionados
        if (!Array.isArray(filterValue) || filterValue.length === 0) {
          return true;
        }
        if (!Array.isArray(itemValue) || itemValue.length === 0) {
          return false;
        }
        return itemValue.some((company: any) => {
          const companyId = company?.id || company;
          return filterValue.includes(companyId);
        });

      case 'boolean':
        return itemValue === filterValue;

      default:
        return true;
    }
  }

  //endregion
}
